<template>
  <div>
    <div class="header">
      <div class="filter-wrap">
        <el-input
          v-model="keyword_search"
          placeholder="请输入分类名称"
          class="input"
          clearable
        ></el-input>
        <el-date-picker
          v-model="dateRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-button
          type="primary"
          class="searchBtn"
          @click="onSearchClick"
        >搜索</el-button>
      </div>
      <el-button
        type="primary"
        class="addBtn"
        @click="onAddClick"
        v-if="operations.includes('新增分类')"
      >新增</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="table"
    >
      <el-table-column
        prop="sort"
        label="序号"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="class_name"
        label="分类名称"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="update_time"
        label="更新时间"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <div class="operation-wrap">
            <span
              class="operation-item"
              @click="onOperationClick(scope.row, 'edit')"
              v-if="operations.includes('编辑分类')"
            >编辑</span>
            <span
              class="danger operation-item"
              @click="onOperationClick(scope.row, 'delete')"
              v-if="operations.includes('删除分类')"
            >删除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <common-pagination
      :total="total"
      :page_size="page_size"
      @page-change="onPageChange"
    ></common-pagination>
    <CategoryDialog
      :title="dialogTitle"
      :type="dialogType"
      :dialogVisible="dialogVisible"
      :row="handleRow"
      @cancel="dialogVisible = false"
      @close="onDialogClose"
      @confirm="onDialogConfirm"
    >
    </CategoryDialog>
  </div>
</template>

<script>
import CommonPagination from "@/components/CommonPagination";
import CategoryDialog from "./components/CategoryDialog";
import {
  getCategoryList,
  addCategoryList,
  editCategoryList,
  deleteCategoryList
} from "@/api/category-manage";
import { mapActions } from "vuex";
import operations from "@/mixins/operations";

export default {
  mixins: [operations],
  data() {
    return {
      tableData: [],
      page_index: 1, //第几页
      page_size: 10,
      total: 0, //总条数
      keyword_search: "",
      dateRange: [],
      dialogTitle: "",
      dialogType: "",
      dialogVisible: false,
      handleRow: {}
    };
  },
  components: {
    CommonPagination,
    CategoryDialog
  },
  mounted() {
    this._getCategoryList();
  },
  computed: {},
  methods: {
    ...mapActions(["getAllFileClass"]),
    async _getCategoryList() {
      const dateRange = this.dateRange ? this.dateRange : [];
      const start_time = dateRange.length ? dateRange[0] : "";
      const end_time = dateRange.length ? dateRange[1] : "";
      const postData = {
        page_index: this.page_index,
        page_size: this.page_size,
        keyword_search: this.keyword_search,
        start_time,
        end_time
      };
      const { status, data } = await getCategoryList(postData);
      if (status === 200) {
        this.tableData = data.result.data;
        this.total = data.result.total;
        this.getAllFileClass();
        console.log(data, "data");
      }
    },
    onPageChange(page) {},
    onOperationClick(row, type) {
      this.handleRow = JSON.parse(JSON.stringify(row));
      this.dialogType = type;
      this.dialogVisible = true;
      switch (type) {
        case "delete":
          this.dialogTitle = "提示";
          break;
        case "edit":
          this.dialogTitle = "编辑分类";
          break;
      }
    },
    onDialogClose() {
      this.dialogVisible = false;
      this.handleRow = {};
      this._getCategoryList();
    },
    async onDialogConfirm(info) {
      switch (this.dialogType) {
        case "edit": {
          const { status } = await editCategoryList(info);
          if (status === 200) {
            this.dialogVisible = false;
            this.$message({
              type: "success",
              message: "编辑成功"
            });
          }
          break;
        }
        case "add": {
          const { status } = await addCategoryList(info);
          if (status === 200) {
            this.dialogVisible = false;
            this.$message({
              type: "success",
              message: "新增成功"
            });
          }
          break;
        }
        case "delete":
          {
            const { status } = await deleteCategoryList(this.handleRow.uuid);
            if (status === 200) {
              this.dialogVisible = false;
            }
          }
          break;
      }
    },
    onAddClick() {
      this.dialogType = "add";
      this.dialogVisible = true;
      this.dialogTitle = "新增分类";
    },
    onSearchClick() {
      this.page_index = 1;
      this._getCategoryList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.header {
  display: flex;
  justify-content: space-between;
}
.filter-wrap {
  display: flex;
  .input {
    width: 160px;
    margin-right: 20px;
  }
  .searchBtn {
    margin-left: 30px;
  }
}
.table {
  .table-wrap();
}
</style>